import React from 'react';
import styled from 'astroturf/react';
import { Popover, PopoverMode, PopoverProps } from './Popover';

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  background: var(--background-white, #fff);
  border-radius: var(--radius-corner-radius-default, 16px);
  border: 1px solid var(--stroke-light, #dddde2);
  overflow: auto;
  padding: 8px 0px;
`;

// This container
const ScrollItems = styled.div`
  overflow: auto;
`;

/**
 * A basic menu component with Academia styling. This component uses
 * {@link Popover} as its parent, adding some nicer styling.
 *
 * ## Basic Usage
 *
 * @example
 *
 * ```tsx
 * import { Menu } from 'js/design_system/Menu';
 * import { PopoverMode } from 'js/design_system/Popover';
 *
 * <Menu
 *   mode={PopoverMode.Click}
 *   placement='bottom-start'
 *   offset={4}
 *   render={() => <p>I'm the popover content!</p>}
 * >
 *   <p>Click me to activate!</p>
 * </Menu>
 * ```
 */
export const Menu: React.FC<PopoverProps> = ({
  mode = PopoverMode.Click,
  closeOnClick = true,
  popoverRef,
  render,
  children,
  ...props
}) => {
  return (
    <Popover
      mode={mode}
      closeOnClick={closeOnClick}
      render={() => {
        return (
          <MenuContainer ref={popoverRef}>
            <ScrollItems>{render()}</ScrollItems>
          </MenuContainer>
        );
      }}
      {...props}
    >
      {children}
    </Popover>
  );
};
